<template>
    <div>    
        <template v-if="session.canEnrolFromDate">
            <div class="purchase-course artist-session">
                <template v-if="buttonOnly">
                    <template v-if="session.isUserEnrolledOnObserver || session.isUserEnrolledOnActive">
                        <div class="text-white mt-1 pt-2 intercom-pushin">You are registered on this session.</div>
                    </template>
                    <template v-else>

                        <template v-if="!isActiveSoldOut">
                            <b-button variant="primary" class="btn-slimpad btn-block btn-white intercom-pushin" @click="enrolClick">
                                Register
                            </b-button>
                        </template>
                        <template v-else-if="!isObserverSoldOut">
                            <b-button variant="primary" class="btn-slimpad btn-block btn-white intercom-pushin" @click="enrolClick">
                                Register
                            </b-button>
                        </template>
                        
                    </template>
                </template>
                <template v-else>
                    
                    <template v-if="session.isUserEnrolledOnObserver || session.isUserEnrolledOnActive">
                        <div class="mt-3">
                            <template v-if="session.isUserEnrolledOnObserver">
                                <h3 class="notif mb-0">You are currently registered on this session with an <strong>observer seat</strong>.</h3>
                            </template>
                            <template v-if="session.isUserEnrolledOnActive">
                                <h3 class="notif mb-0">You are currently registered on this session with a <strong>full access seat</strong>.</h3>
                            </template>
                        </div>
                    </template>
                    <template v-else>

                        <div class="row justify-content-center">
                            <div class="col-md-10">
                                <div class="block left">
                                    <div class="row">
                                        <div class="col-12 col-lg-8">

                                            <template v-if="!isActiveSoldOut">
                                                <h3>Get your place on the front row</h3>
                                                <ul class="list-unstyled">
                                                    <li>
                                                        Sign up now for your interactive place on the front row of the Virtuoso Stage.
                                                        <template v-if="!isFree && isSubscribed">
                                                            The {{ isSubscribed ? session.priceActiveFormatted : session.priceActiveNonSubsFormatted }} booking deposit will be refunded to you after you attend the session.
                                                        </template>
                                                    </li>
                                                </ul>
                                            </template>
                                            <template v-else-if="!isObserverSoldOut">
                                                <div class="narrow-col">
                                                    <h3>Access the live stream</h3>
                                                    <ul class="list-unstyled">
                                                        <li>We are sold out of front row seats but you can still get access to the live stream.</li>
                                                    </ul>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <h3>We are sold out</h3>
                                                <ul class="list-unstyled">
                                                    <li>Sorry, we have no more places available on this event.</li>
                                                    <li>Stay tuned for more events in the future.</li>
                                                </ul>
                                            </template>

                                        </div>
                                        <div class="col-12 col-lg-4 meta-col d-flex align-items-stretch">
                                            <div class="meta-info">

                                                <template v-if="!isSubscribed && !session.is_available_non_subs">
                                                    <div class="text-center">
                                                        <a href="/pricing" class="btn btn-primary btn-slimpad btn-white btn-block">Learn more</a>
                                                        <p class="included">Included in a Virtuoso membership.</p>
                                                    </div>
                                                </template>
                                                <template v-else>

                                                    <template v-if="!session.isUserEnrolledOnObserver && !session.isUserEnrolledOnActive">

                                                        <template v-if="!isActiveSoldOut">
                                                            <b-button variant="primary" class="btn-slimpad btn-block btn-white" @click="enrolClick">
                                                                Register
                                                            </b-button>

                                                            <p class="price text-right mt-2 mb-0">
                                                                {{ isSubscribed ? session.priceActiveFormatted : session.priceActiveNonSubsFormatted }} 
                                                                <template v-if="!isFree && isSubscribed">deposit</template>
                                                            </p>

                                                            <p v-if="isActiveScarce && !isActiveSoldOut" class="text-right mb-0">
                                                                <small>Only {{ activeScarcity }} seats left.</small>
                                                            </p>
                                                        </template>
                                                        <template v-else-if="!isObserverSoldOut">
                                                            <b-button variant="primary" class="btn-slimpad btn-block btn-white" @click="enrolClick">
                                                                Register
                                                            </b-button>

                                                            <p class="price text-right mt-2 mb-0">
                                                                {{ isSubscribed ? session.priceObserverFormatted : session.priceObserverNonSubsFormatted }}
                                                            </p>

                                                            <p v-if="isObserverScarce && !isObserverSoldOut" class="text-right mb-0">
                                                                <small>Only {{ observerScarcity }} seats left.</small>
                                                            </p>
                                                        </template>

                                                    </template>
                                                    
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>

                <b-modal ref="enrolModal" size="lg" :title="'Enrol on ' + session.name" :ok-only="true" ok-variant="link" ok-title="Close">
                    <template v-if="isAuth && isVerified">
                        <enrol-artist-session-button-component 
                            :session="session" 
                            :slug="session.slug" 
                            :seat="orderedSeat" 
                            :user="user"
                            :is-new-user="isNewUser"></enrol-artist-session-button-component>
                    </template>
                    <template v-else-if="isAuth && !isVerified">
                        <p>
                            Thanks for signing up. We have sent you an email to verify your email address.
                        </p>
                        <p>
                            Click the link in your email to verify your email address and then you can enrol on this session.
                        </p>
                    </template>
                    <template v-else>
                        <p>
                            You're one step from enrolling.  We just need a name, email and password.
                            You'll use your free account with us to take part in the session.
                        </p>
                        <auth-basic-component :session="session" :return="session.uri"></auth-basic-component>
                    </template>
                </b-modal>
            </div>
        
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            session: {
                type: Object,
                required: true,
            },
            buttonOnly: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data() {
            return {
                isObserverScarce: false,
                isActiveScarce: false,
                isObserverSoldOut: false,
                isActiveSoldOut: false,
                isAuth: false,
                isVerified: false,
                isSubscribed: false,
                isFree: false,
                user: {},
                isNewUser: false,
                orderedSeat: null,
                
                isBusy: false,
            }
        },

        computed: {
            observerScarcity: function () {
                if(this.session.remainingObserverSeats <= 20) {
                    return 5;
                } else {
                    return this.session.remainingObserverSeats;
                }
            },
            activeScarcity: function () {
                if(this.session.remainingActiveSeats <= 20) {
                    return 3;
                } else {
                    return this.session.remainingActiveSeats;
                }
            },
        },

        mounted() {
            // Scarcity
            if(this.session.remainingObserverSeats <= 50 && this.session.canUserBuyObserver) {
                this.isObserverScarce = true;
            }
            
            if(this.session.remainingActiveSeats <= 20 && this.session.canUserBuyActive) {
                this.isActiveScarce = true;
            }

            // Sold Out
            if(this.session.remainingObserverSeats <= 0 && this.session.canUserBuyObserver) {
                this.isObserverSoldOut = true;
            } else {
                this.orderedSeat = 'observer';
            }
            
            if(this.session.remainingActiveSeats <= 0 && this.session.canUserBuyActive) {
                this.isActiveSoldOut = true;
            } else {
                this.orderedSeat = 'active';
            }

            // User logged in?
            if(window.virtuoso) {
                if(window.virtuoso.is_auth) {
                    this.isAuth = true;
                    this.isVerified = window.virtuoso.is_verified;
                    this.isSubscribed = window.virtuoso.is_subscribed;
                    this.user = window.virtuoso.user;
                }
            }

            // We check server side so it's safe to do whatever here
            if(this.isSubscribed) {
                if(this.orderedSeat == 'active') {
                    this.isFree = this.session.is_active_free; 
                } else if(this.orderedSeat == 'observer') {
                    this.isFree = this.session.is_observer_free; 
                } else {
                    this.isFree = false;
                }
            } else {
                if(this.orderedSeat == 'active') {
                    this.isFree = this.session.is_active_free_non_subs; 
                } else if(this.orderedSeat == 'observer') {
                    this.isFree = this.session.is_observer_free_non_subs; 
                } else {
                    this.isFree = false;
                }
            }
            
            // When payment methods have been updated refresh that section
            Bus.$on("userRegistered", (d) => {
                this.isAuth = true;
                this.user = d;
                this.isNewUser = true;
            });
        },

        methods: {
            // Clicked to apply for a seat
            enrolClick() {
                this.$refs['enrolModal'].show('enrolModal');
            },

            enrolUser() {
                // User does it themselves in the button component
            },
        }
    }
</script>